export const translationManualList = {
  cz: {
    search: "Hledat",
    message: "Odkaz byl zkopírován",
    all: "Vše",
    filteredCategory: "Filtrované kategorie:",
    filteredSubCategory: "Filtrované podkategorie:",
  },
  en: {
    search: "Search",
    message: "Link was copied",
    all: "All",
    filteredCategory: "Filtered Categories:",
    filteredSubCategory: "Filtered Subcategories:",
  },
  de: {
    search: "Suchen",
    message: "Link wurde kopiert",
    all: "Alle",
    filteredCategory: "Gefilterte Kategorien:",
    filteredSubCategory: "Gefilterte Unterkategorien:",
  },
  es: {
    search: "Buscar",
    message: "El enlace ha sido copiado.",
    all: "Todos",
    filteredCategory: "Categorías filtradas:",
    filteredSubCategory: "Subcategorías filtradas:",
  },
  fr: {
    search: "Rechercher",
    message: "Le lien a été copié",
    all: "Tous",
    filteredCategory: "Catégories filtrées:",
    filteredSubCategory: "Sous-catégories filtrées:",
  },
  hu: {
    search: "Keresés",
    message: "A link kimásolva",
    all: "Mind",
    filteredCategory: "Szűrt kategóriák:",
    filteredSubCategory: "Szűrt alkategóriák:",
  },
  nl: {
    search: "Zoeken",
    message: "De link is gekopieerd",
    all: "Alle",
    filteredCategory: "Gefilterde categorieën:",
    filteredSubCategory: "Gefilterde subcategorieën:",
  },
  pl: {
    search: "Szukaj",
    message: "Link został skopiowany",
    all: "Wszystkie",
    filteredCategory: "Filtrowane kategorie:",
    filteredSubCategory: "Filtrowane podkategorie:",
  },
  ru: {
    search: "Поиск",
    message: "Ссылка скопирована",
    all: "Все",
    filteredCategory: "Отфильтрованные категории:",
    filteredSubCategory: "Отфильтрованные подкатегории:",
  },
  sk: {
    search: "Hľadať",
    message: "Odkaz bol skopírovaný",
    all: "Všetky",
    filteredCategory: "Filtrované kategórie:",
    filteredSubCategory: "Filtrované podkategórie:",
  },
  sv: {
    search: "Sök",
    message: "Länken kopierades",
    all: "Alla",
    filteredCategory: "Filtrerade kategorier:",
    filteredSubCategory: "Filtrerade underkategorier:",
  },
  no: {
    search: "Søk",
    message: "Lenken ble kopiert",
    all: "Alle",
    filteredCategory: "Filtrerte kategorier:",
    filteredSubCategory: "Filtrerte underkategorier:",
  },
  da: {
    search: "Søg",
    message: "Linket blev kopieret",
    all: "Alle",
    filteredCategory: "Filtrerede kategorier:",
    filteredSubCategory: "Filtrerede underkategorier:",
  },
  fi: {
    search: "Hae",
    message: "Linkki kopioitiin",
    all: "Kaikki",
    filteredCategory: "Suodatetut kategoriat:",
    filteredSubCategory: "Suodatetut alikategoriat:",
  },
  ar: {
    search: "بحث",
    message: "تم نسخ الرابط",
    all: "الكل",
    filteredCategory: "الفئات المفلترة:",
    filteredSubCategory: "الفئات الفرعية المفلترة:",
  },
};

export default translationManualList;
